import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './sku.scss?inline';

export default class SotbitPropertySku extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        src: { type: String },
        text: { type: String },
        alt: { type: String },
    };

    constructor() {
        super();

        this.src = '';
        this.text = '';
    }

    render() {
        const alt = this.alt ? this.alt : (this.title ?? '');

        return html`<div class="sku ${this.src ? 'sku-img' : ''}" part="sku">
            <sotbit-icon class="icon" part="icon" slot="content" icon="line" size="m" no-padding></sotbit-icon>
            ${this.src
                ? html`<div class="img-wrapper" part="img-wrapper">
                      <img loading="lazy" part="img" class="img" src="${this.src}" alt="${alt || nothing}" />
                  </div>`
                : html`<span class="sku-text" part="text">${this.text}</span>`}
        </div>`;
    }
}
